export default {
  name: 'Product Brand',
  edit: {
    form: 'brand-input',
    label: 'Change the name',
    handler: value => value,
  },
};
